const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
};

// ✅ Add a new sub-user
export const addSubUser = async (
  token: string,
  payload: {
    name: string;
    email: string;
    password: string;
    password_confirmation: string;
  }
): Promise<any> => {
  const url = `${baseURL}/sub-users`;

  const data = new FormData();
  data.append("name", payload.name);
  data.append("email", payload.email);
  data.append("password", payload.password);
  data.append("password_confirmation", payload.password_confirmation);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
      },
      body: data,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

// ✅ Fetch all sub-users
export const getSubUsers = async (token: string): Promise<any> => {
  const url = `${baseURL}/sub-users`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
      },
    });
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

// ✅ Delete sub-user
export const deleteSubUser = async (
  token: string,
  id: number
): Promise<any> => {
  const url = `${baseURL}/sub-users/${id}`;

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
      },
    });
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

// ✅ Update sub-user
export const updateSubUser = async (
  token: string,
  id: number,
  payload: {
    name: string;
    email: string;
    password?: string;
    password_confirmation?: string;
  }
): Promise<any> => {
  const url = `${baseURL}/sub-users/${id}`;

  const data = new FormData();
  data.append("name", payload.name);
  data.append("email", payload.email);
  if (payload.password) data.append("password", payload.password);
  if (payload.password_confirmation)
    data.append("password_confirmation", payload.password_confirmation);

  try {
    const response = await fetch(url, {
      method: "POST", // 🚨 Some APIs require PUT/PATCH, confirm with backend
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
      },
      body: data,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

// ✅ Fetch all get-all-permission
export const getAllPermission = async (token: string): Promise<any> => {
  const url = `${baseURL}/get-all-permission`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
      },
    });
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

// ✅ Add a save User Permissions
export const saveUserPermissions = async (
  token: string,
  payload: { user_id: number; websites: { website_id: number; permissions: number[] }[] }
): Promise<any> => {
  const url = `${baseURL}/save-permission`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

// ✅ getPermissions
export const getPermissions = async (
  token: string,
  id: number,
): Promise<any> => {
  const url = `${baseURL}/get-permission/${id}`
  try {
    const response = await fetch(url, {
      method: "GET", // 🚨 Some APIs require PUT/PATCH, confirm with backend
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
      },
      // body: data,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};